<template>
  <div class="dress-well common-flex">
    <div class="dress-left common-rowUnder">
      <div
        class="dress-categroy"
        :class="selectId == item.id ? 'dress-categroy-select' : ''"
        v-for="(item, index) in categroyList"
        :key="index"
        @click="changeCategroy(item)"
      >
        {{ item.name }}
        <!-- v-if="selectId == item.id && item.num" -->
        <div class="dress-categroy-num" v-if="selectId == item.id &&item.goodsSize">
          +{{ item.goodsSize }}
        </div>
      </div>
    </div>
    <div
      class="dress-mid common-rowUnder"
      v-if="categroyThList && categroyThList.length > 0"
    >
      <div
        v-for="(item, index) in categroyThList"
        :key="index"
        class="dress-categroy-th"
        :class="selectThId == item.id ? 'dress-categroy-select-th' : ''"
        @click="selectTh(item)"
      >
        {{ item.name }}
      </div>
    </div>
    <div class="dress-right common-rowUnder">
      <div
        class="dress-details-top common-flex common-justify-between common-align-center"
      >
        <div class="details-name">{{selectName}}</div>
        <Form class="search-form" @submit.native.prevent>
          <Input
            icon="ios-search"
            size="large"
            v-model="params.goodName"
            @on-click="search"
            @keyup.enter.native="search('')"
            :placeholder="$t('fabricLibrary.search')"
            class="search-input"
          />
        </Form>
      </div>
      <div class="product-grid">
        <div v-if="loading" class="loading-container">
          <Spin size="large"></Spin>
          <div class="loading-text">加载中...</div>
        </div>
        <div
          class="dress-product"
          @click="toDetails(item)"
          v-for="item in pardut"
          :key="item.id"
        >
          <div class="product-image-container">
            <img
              class="dress-product-img"
              :src="getImageUrl(item.previewImage)"
              :alt="item.goodName"
              @error="onImageError(item.id, $event)"
              @load="onImageLoaded(item.id)"
            />
            <div class="image-loading" v-if="!item.imageLoaded">
              <Spin size="small"></Spin>
            </div>
          </div>
          <div class="dress-product-name">{{ item.goodName }}</div>
          <div class="dress-product-price">{{ item.price }}</div>
        </div>
        <div class="dress-product-nodate-box" v-if="pardut.length==0 && !loading">
          <img src="../../assets/images/null.png" alt="">
          <div class="dress-product-nodate">
            {{ $t("noDate") }}
          </div>
        </div>
      </div>
      <div class="pagination-container" v-if="total">
        <Page
          @on-change="changePage"
          :total="total"
          :page-size="params.pageSize"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
export default {
  data() {
    return {
      categroyList: [],
      categroyThList: [],
      selectId: 1,
      selectName:'',
      selectThId: 8,
      params: {
        goodName: "",
        pageSize: 20,
        pageNum: 1,
        categoryId: "",
      },
      pardut: [],
      loading: false,
      defaultImg: require("../../assets/images/none-img.png"),
      total: 0,
    };
  },
  mounted() {
    // this.changeCategroy(this.categroyList[0])
    this.selectDictBasicTree();
  },
  methods: {
    ...mapActions(["categoryListAction", "goodsListAction"]),
    changePage(e) {
      this.params.pageNum = e;
      this.getPro();
    },
    // 获取产品列表
    getPro() {
      this.loading = true;
      // 先清空当前产品列表，避免显示旧图片
      this.pardut = [];
      
      this.goodsListAction(this.params).then((res) => {
        // 为每个产品添加图片加载状态
        const products = res.data || [];
        this.pardut = products.map(product => ({
          ...product,
          imageLoaded: false
        }));
        this.total = res.total;
      }).finally(() => {
        this.loading = false;
      });
    },
    // 图片加载错误处理
    onImageError(productId, e) {
      e.target.src = this.defaultImg;
      // 立即更新，避免延迟
      this.$nextTick(() => {
        const product = this.pardut.find(p => p.id === productId);
        if (product) {
          product.imageLoaded = true;
        }
      });
    },
    // 图片加载完成处理
    onImageLoaded(productId) {
      // 立即更新，避免延迟
      this.$nextTick(() => {
        const product = this.pardut.find(p => p.id === productId);
        if (product) {
          product.imageLoaded = true;
        }
      });
    },
    selectTh(e) {
      this.selectThId = e.id;
      this.params.categoryId = e.id;
      this.params.goodName = ''
      this.selectName = e.name
      // 有二级获取产品
      this.getPro();
    },
    selectDictBasicTree() {
      this.categoryListAction().then((res) => {
        console.log(123,res)
        this.categroyList = res.data;
        this.changeCategroy(this.categroyList[0]);
      });
    },
    search() {
      this.params.pageNum = 1
      this.params.categoryId=null;
      this.getPro();
    },
    toDetails(item) {
      let routerJump = this.$router.resolve({
        path: '/dressWellDetails',
        query: {id: item.id}
      });
      window.open(routerJump.href, '_blank')
    },
    changeCategroy(e) {
      this.selectId = e.id;
      this.params.goodName = ''
      this.selectName = e.name
      if (e.children && e.children.length > 0) {
        this.categroyThList = e.children;
        this.selectTh(this.categroyThList[0]);
      } else {
        this.params.categoryId = e.id;
        this.categroyThList = [];
        // 没有二级直接获取产品
        this.getPro();
      }
    },
    getImageUrl(imageUrl) {
      if (!imageUrl) return this.defaultImg;
      return `${imageUrl}?max_width=380`;
    },
  },
};
</script>
<style scoped lang="less">
.dress-well {
  background-color: #fff;
}

.product-grid {
  display: flex;
  flex-wrap: wrap;
  padding-left: 20px;
  position: relative;
  min-height: 300px;
}

.loading-container {
  position: absolute;
  top: 100px;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
}

.loading-text {
  margin-top: 15px;
  color: #666;
}

.search-form {
  margin-right: 40px;
}

.search-input {
  width: 380px;
  color: #081938;
  border-radius: 4px;
  transition: all 0.3s;
  
  &:hover, &:focus {
    box-shadow: 0 0 0 1px rgba(10, 77, 204, 0.3);
  }
}

.pagination-container {
  margin: 20px 0 30px;
  text-align: center;
}

.dress-product-nodate {
  font-size: 16px;
  margin: 10px auto 30px;
  text-align: center;
  color: #333;
}

.dress-product-nodate-box {
  margin: 40px auto;
  text-align: center;
  
  img {
    width: 360px;
    height: 320px;
  }
}

.dress-well {
  .product-image-container {
    overflow: hidden;
    border-radius: 4px;
    background: #f8f8f8;
    margin-bottom: 20px;
    height: 190px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }
  
  .image-loading {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(248, 248, 248, 0.7);
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .dress-product-img {
    width: 190px;
    height: 190px;
    object-fit: contain;
    transition: transform 0.3s ease;
    
    &:hover {
      transform: scale(1.05);
    }
  }
  
  .dress-product-name {
    height: auto;
    min-height: 19px;
    font-size: 16px;
    font-family: Roboto-Medium, Roboto;
    font-weight: 500;
    color: #081938;
    line-height: 19px;
    text-align: center;
    margin-bottom: 12px;
    padding: 0 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  
  .dress-product-price {
    text-align: center;
    font-weight: 500;
    color: #081938;
    font-size: 16px;
  }
  
  .dress-mid {
    height: calc(100vh - 60px);
    background: #f8f8f8;
    overflow-y: auto;
    overflow-x: hidden;
    padding-top: 19px;
  }
  
  .dress-product {
    width: 190px;
    margin-bottom: 28px;
    margin-left: 20px;
    margin-right: 20px;
    cursor: pointer;
    transition: all 0.3s ease;
    padding: 10px;
    border-radius: 4px;
    
    &:hover {
      transform: translateY(-5px);
      box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
    }
  }
  
  .dress-left {
    width: 240px;
    height: calc(100vh - 60px);
    overflow-y: auto;
    overflow-x: hidden;
    padding-top: 19px;
    background: #fff;
    border-right: 1px solid #eaeaea;
  }
  
  .dress-categroy {
    width: 240px;
    height: 52px;
    line-height: 52px;
    background: #ffffff;
    font-size: 14px;
    font-family: Roboto-Regular, Roboto;
    font-weight: 400;
    color: #081938;
    text-align: left;
    padding-left: 40px;
    cursor: pointer;
    transition: all 0.2s ease;
    position: relative;
    
    &:hover {
      background: rgba(10, 77, 204, 0.05);
    }
  }
  
  .dress-categroy-th {
    width: 159px;
    height: 52px;
    background: #f8f8f8;
    line-height: 52px;
    font-size: 14px;
    font-family: Roboto-Regular, Roboto;
    font-weight: 400;
    color: #081938;
    padding-left: 20px;
    text-align: left;
    cursor: pointer;
    transition: all 0.2s ease;
    
    &:hover {
      background: #f0f0f0;
      color: #0a4dcc;
    }
  }
  
  .dress-categroy-select-th {
    background: #fff;
    color: #0a4dcc;
    font-weight: 500;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);
  }
  
  .dress-right {
    flex: 1;
    background: #ffffff;
    height: calc(100vh - 60px);
    overflow-y: auto;
    overflow-x: hidden;
  }
  
  .dress-categroy-select {
    position: relative;
    background: rgba(10, 77, 204, 0.1);
    font-size: 16px;
    font-family: Roboto-Medium, Roboto;
    font-weight: 500;
    color: #0a4dcc;
  }
  
  .dress-categroy-select::after {
    content: "";
    width: 4px;
    height: 52px;
    background: #0a4dcc;
    position: absolute;
    left: 0;
    top: 0;
    font-size: 12px;
  }
  
  .dress-categroy-num {
    height: 20px;
    background: #0a4dcc;
    border-radius: 10px;
    padding: 0 8px;
    color: #fff;
    line-height: 20px;
    position: absolute;
    right: 10px;
    top: 0;
    bottom: 0;
    margin-top: auto;
    margin-bottom: auto;
    font-size: 12px;
    font-weight: normal;
  }
  
  .dress-details-top {
    padding-top: 40px;
    margin-bottom: 40px;
  }
  
  .details-name {
    font-size: 24px;
    font-family: Roboto-Medium, Roboto;
    font-weight: 500;
    color: #081938;
    line-height: 24px;
    padding-left: 40px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/dressWell/dressWell.vue